import React, { useState, useEffect } from 'react';
import { adSurfaceEnabled } from '../../config/ads';
import { adSlotVisible } from '../../utils/adsEnabled';
import { isValidAdDestination } from '../../utils/adDestinationUrl';
import {
  BannerRoot,
  BannerLink,
  BannerOverlay,
  DismissBtn,
  BadgeRow,
  AdBadge,
  SponsorText,
} from './StaticAdBanner.styled';

export default function StaticAdBanner({ ad, variant = 'full', pageKey, onImpression, onLinkClick }) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!onImpression || !ad?.managedCampaignId) return;
    onImpression();
  }, [onImpression, ad?.managedCampaignId]);

  if (!adSurfaceEnabled() || dismissed || !ad?.image) return null;
  if (pageKey && !adSlotVisible(pageKey)) return null;

  const dest = isValidAdDestination(ad.url);
  const onNavigate = (e) => {
    if (!dest) {
      e.preventDefault();
      return;
    }
    onLinkClick?.(e);
  };

  return (
    <BannerRoot>
      <BannerLink
        href={dest ? ad.url : '#'}
        onClick={onNavigate}
        target={dest ? '_blank' : undefined}
        rel={dest ? 'noopener noreferrer sponsored' : undefined}
        $variant={variant === 'inline' ? 'inline' : 'full'}
      >
        <img src={ad.image} alt={ad.title} loading="lazy" decoding="async" />
        <BannerOverlay aria-hidden />
      </BannerLink>
      <DismissBtn type="button" onClick={() => setDismissed(true)} aria-label="Dismiss ad">
        ×
      </DismissBtn>
      <BadgeRow>
        <AdBadge>Ad</AdBadge>
        <SponsorText>{ad.sponsor}</SponsorText>
      </BadgeRow>
    </BannerRoot>
  );
}
